"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Text } from "@nxt-costco-com/forge-components";
import { CA_BC } from "../../../constants.js";
import { useProductTileData } from "../../../../../../hooks/useProductTileData/index.js";
import { DeliveryChannelBadge } from "./DeliveryChannelBadge/index.js";
import { MDOChannelBadge } from "./MDOChannelBadge/index.js";
import { WarehouseChannelBadge } from "./WarehouseChannelBadge/index.js";
import { availabilityInfoWrapperStyles } from "./styles.js";
const AvailabilityInfo = () => {
  const { normalizedData, translationsConfig } = useProductTileData();
  const { availabilityInfoData, deliveryChannelData, productInfoData } = normalizedData;
  const {
    inWarehouseAvailabilityText,
    inWarehouseChannelBadgeData,
    bopimStatus
  } = availabilityInfoData || {};
  const { partNumber } = productInfoData;
  const { translations, keys, urls } = translationsConfig || {};
  const { samedayDeliveryIcon } = urls || {};
  return /* @__PURE__ */ jsxs(
    Box,
    {
      "data-testid": `AvailabilityInfo_${partNumber}`,
      sx: availabilityInfoWrapperStyles,
      children: [
        inWarehouseAvailabilityText && (keys == null ? void 0 : keys["productAPIClientId"]) === CA_BC && (translations == null ? void 0 : translations.warehouseavailability) && /* @__PURE__ */ jsx(Text, { uniqueId: `inWarehouseAvailability_${partNumber}`, children: translations.warehouseavailability }),
        deliveryChannelData && /* @__PURE__ */ jsx(
          DeliveryChannelBadge,
          {
            ...deliveryChannelData,
            translations,
            samedayDeliveryIcon,
            uniqueId: partNumber
          }
        ),
        inWarehouseChannelBadgeData ? bopimStatus && inWarehouseChannelBadgeData.status === "out-of-stock" ? /* @__PURE__ */ jsx(
          MDOChannelBadge,
          {
            translations,
            uniqueId: partNumber
          }
        ) : /* @__PURE__ */ jsx(
          WarehouseChannelBadge,
          {
            ...inWarehouseChannelBadgeData,
            translations,
            uniqueId: partNumber
          }
        ) : bopimStatus && /* @__PURE__ */ jsx(
          MDOChannelBadge,
          {
            translations,
            uniqueId: partNumber
          }
        )
      ]
    }
  );
};
export {
  AvailabilityInfo
};
